function getCloseButtons() {

    return [...document.querySelectorAll('.js_aboutTeamMember__closeButton')];
}

function getMembers() {

    return [...document.querySelectorAll('.js_aboutTeamMember')];
}

function getPopup(popupId) {

    return document.querySelector(`.js_aboutTeamMember--popup[data-member-popup-id="${popupId}"]`);
}

function getTeam() {

    return document.querySelector('.js_aboutTeam__team');
}

function showTeamScrollbar() {
    const team = getTeam();

    if (team) {
        team.classList.remove('aboutTeam__team--hideScrollbar');
    }
}

function hideTeamScrollbar() {
    // for Chrome & Firefox bug whereby scrollbars underneath fixed position
    // overlays are visible regardless of z-index
    // 
    // in this case the scrollbar for the team CSS slider is visible through
    // the team member popup
    const team = getTeam();

    if (team) {
        team.classList.add('aboutTeam__team--hideScrollbar');
    }
}

function getPopupId(popup) {

    return popup.getAttribute('data-member-popup-id');
}

function getTargetPopupId(el) {

    return el.getAttribute('data-for-member-popup');
}

function getPopups() {
    
    return [...document.querySelectorAll('.js_aboutTeamMember--popup')];
}

function matchesPopup(popup, popupId) {

    return getPopupId(popup) == popupId;
}

function openPopup(popup) {
    popup.classList.add('aboutTeamMember--popupOpen')
}

function closePopup(popup) {
    popup.classList.remove('aboutTeamMember--popupOpen');
}

function maybeOpenPopup(member) {
    const popups = getPopups();
    const popupId = getTargetPopupId(member);

    popups.filter(popup => matchesPopup(popup, popupId)).forEach(openPopup);
    popups.filter(popup => !matchesPopup(popup, popupId)).forEach(closePopup);
    hideTeamScrollbar();
}

function maybeClosePopup(button) {
    const popupId = getTargetPopupId(button);
    const popup = getPopup(popupId);

    if (popup) {
        closePopup(popup);
        showTeamScrollbar();
    }
}

function init() {
    const members = getMembers();
    const closeButtons = getCloseButtons();

    members.forEach(member => member.addEventListener('click', e => maybeOpenPopup(member)));

    closeButtons.forEach(button => button.addEventListener('click', e => maybeClosePopup(button)));
}

$(document).ready(init);
